// Pure decision for ModuleGuard so the fail-closed logic is unit-testable without a DOM.
export type ModuleGuardView = 'loading' | 'unavailable' | 'locked' | 'allow';

export interface ModuleGuardInputs {
  hasHydrated: boolean;
  isBootstrapped: boolean;
  isLoading: boolean;
  isLoaded: boolean;
  moduleEnabled: boolean;
}

export function resolveModuleGuardView({
  hasHydrated,
  isBootstrapped,
  isLoading,
  isLoaded,
  moduleEnabled,
}: ModuleGuardInputs): ModuleGuardView {
  // Legitimate async bootstrap window: never fail open, show a loading state.
  if (!hasHydrated || !isBootstrapped || isLoading) return 'loading';
  // Loaded-but entitlements never arrived: fail closed (retryable), do not render children.
  if (!isLoaded) return 'unavailable';
  // Loaded and known: deny when the module is absent.
  if (!moduleEnabled) return 'locked';
  return 'allow';
}
